module.exports = __webpack_public_path__ + "img/default_cover_1_1.d4cfbd60.png";